import { Action } from '../actions';
import {
    CHANGE_COMMON_PRICE_EDITOR,
    CLOSE_COMMON_PRICE_EDITOR,
    OPEN_COMMON_PRICE_EDITOR,
    UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA
} from '../actions/commonPriceEditor';
import { SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR } from '../actions/phrases-grid';
import { SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR } from '../actions/retargetingCommonPriceEditor';
import { validateCommonPriceValue } from '../service/CommonPriceEditorHelper/CommonPriceEditorHelper';
import { CommonPriceEditorState } from '../typings/commonPriceEditorState';
import { State } from '../typings/state';

const initialState = {
    isVisible: false,
    isInProgress: false,
    errors: [],
    commonPriceValue: 0
};

export function commonPriceEditor(
    state: CommonPriceEditorState = initialState,
    action: Action,
    fullState: State
): CommonPriceEditorState {
    switch (action.type) {
        case OPEN_COMMON_PRICE_EDITOR: {
            const {
                commonData: {
                    client: { workCurrency },
                    constants
                }
            } = fullState;
            const { commonPriceValue } = state;
            const { bigRate } = constants && constants.currencyConstants[workCurrency];

            return {
                ...state,
                isVisible: true,
                commonPriceValue: bigRate !== undefined ? bigRate : commonPriceValue
            };
        }

        case CLOSE_COMMON_PRICE_EDITOR:
            return initialState;

        case CHANGE_COMMON_PRICE_EDITOR: {
            if (action.validationParams === undefined) {
                return state;
            }

            return {
                ...state,
                commonPriceValue: action.value,
                errors: validateCommonPriceValue(action.value, action.validationParams)
            };
        }

        case SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR:
        case SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR: {
            return {
                ...state,
                isInProgress: true
            };
        }

        case UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA: {
            return {
                ...state,
                isInProgress: action.isInProgress
            };
        }

        default: {
            return state;
        }
    }
}
